module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Singlespil","track":"Singles","ontario":"Singlespil"}}